import { calcFrom, getSizeByType } from '@helpers/chartHelpers';
import { Aggregator, FrequencyType, WidgetTypes } from '@helpers/Enums';
import { ComponentType } from '@interfaces/component-type';
import { IWidgetProperties } from '@interfaces/IDinamicDashboards';
import DashboardService from '@services/Dashboard';
import EhssDashboardService from '@services/ehss/Dashboard';
import EhssTicketEventService from '@services/ehss/EhssTicketEvent';
import AuditedService from '@services/ehss/Audited';
import TicketService from '@services/TicketEvent';
import NotificationComponent from '@src/helpers/_showNotifications';
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';
import I18n from '@src/i18n';
import { Button, Checkbox, Col, DatePicker, Input, InputNumber, Modal, Radio, Row, Select, TimePicker } from 'antd';
import pt_BR from 'antd/lib/locale-provider/pt_BR';
import moment from 'moment';
import React, { Component } from 'react';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import styled, { injectGlobal } from 'styled-components';

import AppContext from '../services/Context';
import CheckboxSearch from './CheckboxSearch';
import ComponentsModal from './ComponentsModal';
import UsersModalComponent from './UsersModalComponent';
import WidgetBox from './WidgetBox';
import Counter from './widgetTypes/Counter';
import Goals from './widgetTypes/Goals';
import List from './widgetTypes/List';
import RangeChart from './widgetTypes/RangeChart';
import BarChart from './widgetTypes/BarChart';
import GoalsChart from './widgetTypes/GoalsChart';
import Table from './widgetTypes/Table';

const _auditedService: AuditedService = new AuditedService()
const _formflowService: ProcessRequestsInterceptor = new ProcessRequestsInterceptor()
const _DashboardService: any = new DashboardService()
const _TicketEvent: any = new TicketService()
const _EhssTicketEvent: any = new EhssTicketEventService();
const _EhssDashboardService: any = new EhssDashboardService();
const dashboardPreview = require('@src/images/dashboard.png');
const { RangePicker } = DatePicker;

// TODO: REFACTOR THE INCONSISTENT DIVS THAT FORMAT THE COMPONENT IN THE SAME WAY
type PropType = {
  content?: any
  unit: any;
  pillar: any;
  matchData?: any;
  changeTitle?: any;
}

type StateType = {
  isRegisterModalVisible: boolean;
  isUsersModalVisible: boolean;
  isComponentsModalVisible: boolean;
  data: any;
  processes: any;
  processesFiltered: any;
  selectedProcessId?: string
  userIds?: string[]
  nonSelectedUsers: string[];
  lastUserId: any;
  confirmedUsers: any;
  selectedProcessData: any;
  componentKeys?: string[];
  frequency: any;
  widgetTitle?: string;
  dashboardInfo: any;
  widgets: any;
  id: string;
  widgetType?: any;
  shouldResetCheckboxState: boolean;
  widgetEdition: boolean;
  editingModalID: any;
  previewData?: any;
  loadPreview: boolean;
  update?: boolean;
  dateType: string;
  specific?: any;
  minRange?: number;
  maxRange?: number;
  recurrency: boolean;
  aggregatorType: any;
  auditedOut?: boolean;
  auditedGuest?: boolean;
  auditorGuest?: boolean;
  year: number;
  auditors: string[];
  nonSelectedAuditors: string[];
  isAuditorsModalVisible: boolean;
  auditorsIds?: string[];
  confirmedAuditors?: string[];
  hourFrom?: any;
  hourTo?: any;
};

export default class DinamicDashboardComponent extends React.Component<PropType, StateType> {
  constructor(props: PropType) {
    super(props)

    this.state = {
      data: [],
      isRegisterModalVisible: false,
      processes: [],
      processesFiltered: [],
      selectedProcessId: '',
      isUsersModalVisible: false,
      userIds: [],
      nonSelectedUsers: [],
      lastUserId: [],
      confirmedUsers: [],
      isComponentsModalVisible: false,
      selectedProcessData: [],
      componentKeys: [],
      frequency: {
        times: undefined,
        type: FrequencyType.DAYS
      },
      widgetTitle: '',
      dashboardInfo: [],
      widgets: undefined,
      id: '',
      widgetType: undefined,
      shouldResetCheckboxState: false,
      widgetEdition: false,
      editingModalID: undefined,
      loadPreview: false,
      dateType: 'frequency',
      specific: {
        from: undefined,
        to: undefined,
      },
      minRange: undefined,
      maxRange: undefined,
      recurrency: false,
      aggregatorType: Aggregator.COUNT,
      auditedOut: false,
      auditedGuest: false,
      auditorGuest: false,
      year: new Date().getFullYear(),
      auditors: [],
      nonSelectedAuditors: [],
      isAuditorsModalVisible: false,
      auditorsIds: [],
      confirmedAuditors: [],
      hourFrom: null,
      hourTo: null
    }

    this.onDragEnd = this.onDragEnd.bind(this);
  }

  async reorder(list: any[], startIndex: any, endIndex: any) {
    const { widgets } = this.state;

    let changeEnd;
    if (widgets[parseInt(endIndex.droppableId)][parseInt(endIndex.index)]) {
      changeEnd = widgets[parseInt(endIndex.droppableId)][parseInt(endIndex.index)].position
    } else {
      changeEnd = widgets[parseInt(endIndex.droppableId)][parseInt(endIndex.index) - 1].position
    }

    const result = list;
    const indexStart = parseInt(startIndex.index)
    const indexEnd = parseInt(changeEnd)
    const [removed] = result.splice(indexStart, 1);
    result.splice(indexEnd, 0, removed);
    return { result, removed, indexEnd };
  };

  async onDragEnd(result: DropResult) {
    if (!result.destination) {
      return;
    }

    const reorder = await this.reorder(
      this.state.dashboardInfo,
      result.source,
      result.destination
    );
    this.setState({ dashboardInfo: reorder.result });
    await this.dashboardRowGetter()
    if (this.props.pillar === 'EHSS') {
      await _EhssDashboardService.editWidgetPosition(this.state.id, this.props.unit, reorder.removed.id, reorder.indexEnd)
    } else {
      await _DashboardService.editWidgetPosition(this.state.id, this.props.unit, reorder.removed.id, reorder.indexEnd)
    }

  }

  componentWillMount() {
    this.intialData()
  }

  intialData = async () => {
    await this.getProcesses()
    await this.getDashboardFirstInfo()
    await this.dashboardRowGetter()
  }

  getDashboardFirstInfo = async () => {
    let dashboardFetch
    if (this.props.pillar === 'EHSS') {
      dashboardFetch = await _EhssDashboardService.paging({ unit: this.props.unit })
    } else {
      const dashboardSingle = await _DashboardService.getById(this.props.matchData.params.id, this.props.unit)
      dashboardFetch = { items: [dashboardSingle] }
      this.props.changeTitle(dashboardSingle.title)
    }
    let dashboardInfo: any = []
    for (let item of dashboardFetch.items) {
      if (item.widgets) {
        for (let widget of item.widgets) {
          if (widget.type === WidgetTypes.GOALS || widget.type === WidgetTypes.TABLE) {
            dashboardInfo.push(this.getExistentWidgetsGoals(widget))
          }
          else if (widget.type === WidgetTypes.GOALS_CHART) {
            let data = await this.getExistentWidgetsGoalsChart(widget)
            data = Object.assign({}, { data, ...widget })
            dashboardInfo.push(data)
          } else {
            dashboardInfo.push(this.getExistentWidgets(widget))
          }
        }
      }
      else dashboardInfo.unshift('')
    }
    const dashboardArray = await Promise.all(dashboardInfo)
    this.setState({ id: dashboardFetch.items[0].id, dashboardInfo: dashboardArray })
  }

  filterProcessByType = async (model: any, componentType: ComponentType) => {

    const filtered: any = {
      items: []
    };
    model.items.map((process: any, i: number) => {
      for (let section of process.sections) {
        if (section.components.findIndex((e: any) => e.type === componentType) !== -1) {
          if (filtered.items.findIndex((p: any) => p.id === model.items[i].id) === -1) {
            filtered.items.push(model.items[i])
          }
        }
      }
    })
    return filtered
  }

  getProcesses = async (filter?: any) => {
    let data: any = []
    if (filter && filter === 'clear') {
      data = await this.state.processesFiltered
    } else {
      data = await _formflowService.paging({
        unit: this.props.unit,
        to: undefined,
        from: undefined,
        limit: 100,
      }, ['id', 'name', 'paths', 'sections', 'auditedByMouth']);
    }

    this.setState({ processesFiltered: data })

    if (filter && filter !== 'clear') {
      const filterProcess = await this.filterProcessByType(data, filter)
      this.setState({ processes: filterProcess })
    } else {
      this.setState({ processes: data })
    }
  }

  setprocess = async (processId: string) => {
    let processData = this.state.processes.items.filter((process: any) => process.id === processId)
    this.setState({ selectedProcessId: processId, selectedProcessData: processData })
  }

  dashboardRowGetter = () => {
    //returns me an array that constains other arrays, corresponding to each row in the column
    let rowArray = []
    const returnedArray = []
    let counter = 0;
    for (let i in this.state.dashboardInfo) {
      if (this.state.dashboardInfo[i] && this.state.dashboardInfo[i].type === 0) {
        continue;
      }
      const widgetObject = Object.assign({}, this.state.dashboardInfo[i], { size: getSizeByType(this.state.dashboardInfo[i] ? this.state.dashboardInfo[i].type : {}) }, { position: i })

      if (counter + widgetObject.size <= 24 && (parseInt(i) + 1) !== this.state.dashboardInfo.length) {
        rowArray.push(widgetObject)
        counter += widgetObject.size
      }
      else if ((parseInt(i) + 1) === this.state.dashboardInfo.length) {
        rowArray.push(widgetObject)
        returnedArray.push(rowArray)
      }
      else {
        returnedArray.push(rowArray)
        rowArray = []
        rowArray.push(widgetObject)
        counter = widgetObject.size
      }
    }
    this.setState({ widgets: returnedArray })
  }

  getExistentWidgets = async (widget: any) => {
    let query: any
    if (widget.frequency) {
      query = {
        unit: this.props.unit,
        owners: widget.userIds,
        components: widget.componentKeys,
        status: widget.status,
        from: calcFrom(widget.frequency.times, widget.frequency.type)
      }
    }
    else {
      query = {
        unit: this.props.unit,
        owners: widget.userIds,
        components: widget.componentKeys,
        status: widget.status,
        from: widget.specific.from,
        to: widget.specific.to || Date.now(),
        hourFrom: widget.specific.hourFrom || null,
        hourTo: widget.specific.hourTo || null
      }
    }
    const result = await _TicketEvent.getDashboardData(widget.processId, query)
    const dashboardInfo = this.state.dashboardInfo
    let original = widget;
    original.data = result;
    dashboardInfo.push(original)
    return original
  }

  getExistentWidgetsGoals = async (widget: any) => {
    let query: any = {}
    if (widget.auditedGuest) {
      query.auditedGuest = widget.auditedGuest
    }
    if (widget.auditedOut) {
      query.auditedOut = widget.auditedOut
    }
    if (widget.auditorGuest) {
      query.auditorGuest = widget.auditorGuest
    }

    if (widget.specific && (widget.type === WidgetTypes.GOALS)) {
      const year = new Date(widget.specific.to).getFullYear()
      if (widget.auditors && widget.auditors.length > 0) query.auditors = widget.auditors
      const result = await _EhssTicketEvent.getProcessGoals(query, this.props.unit, widget.processId, year)
      const dashboardInfo = this.state.dashboardInfo
      let original = widget
      original.data = result
      dashboardInfo.push(original)
      return original
    } else {
      if (widget.frequency) {
        query = {
          unit: this.props.unit,
          owners: widget.userIds,
          components: widget.componentKeys,
          status: widget.status,
          from: calcFrom(widget.frequency.times, widget.frequency.type)
        }
      }
      else {
        query = {
          unit: this.props.unit,
          owners: widget.userIds,
          components: widget.componentKeys,
          status: widget.status,
          from: widget.specific.from,
          to: widget.specific.to || Date.now(),
          hourFrom: widget.specific.hourFrom || null,
          hourTo: widget.specific.hourTo || null
        }
      }
      const result = await _EhssTicketEvent.getDashboardData(widget.processId, query)
      const dashboardInfo = this.state.dashboardInfo
      let original = widget;
      original.data = result;
      dashboardInfo.push(original)
      return original
    }
  }

  getExistentWidgetsGoalsChart = async (widget?: any) => {
    let year = this.state.year ? this.state.year : new Date().getFullYear()
    
    const query = {
      unit: this.props.unit,
      from: moment(`01/01/${year}`).format('X'),
      auditedOut: !!this.state.auditedOut,
      auditorGuest: !!this.state.auditorGuest,
      auditedGuest: !!this.state.auditedGuest
    }
    if (this.state.confirmedUsers && this.state.confirmedUsers.length > 0) query.audited = this.state.confirmedUsers.map((u) => u.id)
    if (this.state.auditorsIds && this.state.auditorsIds.length > 0) query.auditor = this.state.auditorsIds.map((u) => u.id)
    if (this.state.confirmedAuditors && this.state.confirmedAuditors.length > 0) query.auditor = this.state.confirmedAuditors.map((u) => u.id)
    if (widget && widget.auditors && widget.auditors.length > 0) query.auditor = widget.auditors.map((u) => u.id)

    const processId = this.state.selectedProcessId || widget.processId
    const data = { executed: null, audited: null, allAudited: null, year }
    data.executed = await _TicketEvent.getDashboardAuditorAudited(query, processId);
    let audited = this.state.processes.items.find((p: any) => p.id === processId).auditedByMouth

    if (!audited) {
      const allAudited = await _auditedService.paging({
        unit: this.props.unit,
        process: this.state.selectedProcessId,
        from: query.from,
        limit: 999,
      })
      data.allAudited = allAudited.count
    } else {
      data.audited = audited
    }
    if (query.auditor) data.auditors = query.auditor
    return data
  }

  handleComponentSearch = async (event: any) => {
    event.preventDefault();
  }


  handleWidgetTypeChange = async (value: any) => {
    this.setState({ widgetType: value })
    if (value === WidgetTypes.GROUP) {
      await this.getProcesses(ComponentType.GOTO)
    } else {
      await this.getProcesses('clear')
    }
    this.onClickViewPreview()
  }

  handleYearChange = async (year: any) => {
    this.setState({ year })
  }

  aggregatorHandler = async (value: any) => {
    this.setState({ aggregatorType: value })
  }

  setSelectedIds = async (usersArray: string[], nonSelectedUsers: string[]) => {
    this.setState({ userIds: usersArray, nonSelectedUsers })
  }

  setSelectedAuditors = async (auditorsArray: string[], nonSelectedAuditors: string[]) => {
    this.setState({ auditorsIds: auditorsArray, nonSelectedAuditors })
  }

  handleUsersModalSave = async () => {
    this.setState((prevState) => ({ confirmedUsers: prevState.userIds, isUsersModalVisible: false }))
  }

  handleAuditorsModalSave = async () => {
    this.setState((prevState) => ({ confirmedAuditors: prevState.auditorsIds, isAuditorsModalVisible: false }))
  }

  handleUsersModalCancel = () => {
    this.setState((prevState) => ({ isUsersModalVisible: false, userIds: prevState.confirmedUsers }))
  }

  handleAuditorsModalCancel = () => {
    this.setState((prevState) => ({ isAuditorsModalVisible: false, auditorsIds: prevState.confirmedAuditors }))
  }

  componentsToState = async (componentKeys: string[]) => {
    this.setState({ componentKeys })
  }

  deleteWidgetByIndex = async (id: any, widgetID: string) => {
    if (this.props.pillar === 'EHSS') {
      _EhssDashboardService.deleteWidget(this.props.unit, id, widgetID)
    } else {
      _DashboardService.deleteWidget(this.props.unit, id, widgetID)
    }
    let newDashboardInfo = this.state.dashboardInfo.filter((e: any) => e.id !== widgetID)
    await this.setState({ dashboardInfo: newDashboardInfo })
    await this.dashboardRowGetter()
  }
  toggleWidgetCreation = () => {
    this.setState({
      isRegisterModalVisible: !this.state.isRegisterModalVisible,
      editingModalID: undefined,
      previewData: [],
      widgetType: undefined,
      widgetTitle: undefined,
      selectedProcessId: undefined,
      componentKeys: undefined,
      userIds: undefined,
      frequency: {
        times: undefined,
        type: FrequencyType.DAYS
      },
      specific: {
        from: undefined,
        to: undefined,
      },
      auditedGuest: undefined,
      auditedOut: undefined,
      auditorGuest: undefined,
      confirmedAuditors: [],
      confirmedUsers: undefined,
      shouldResetCheckboxState: true
    });
  }

  handleInput = async (e: any) => {
    this.setState({ widgetTitle: e.target.value })
  }
  resetCheckboxStateHandler = async (trueOrFalse: boolean) => {
    this.setState({ shouldResetCheckboxState: trueOrFalse })
  }

  editWidgets = async (objectInfo: IWidgetProperties) => {
    const {
      widgetID,
      widgetTitle,
      date,
      data,
      widgetType,
      selectedProcessId,
      componentKeys,
      userIds,
      minRange,
      maxRange,
      recurrency,
      aggregator,
      auditedGuest,
      auditedOut,
      auditorGuest,
      auditors
    } = objectInfo

    const paths = this.state.processes.items.find((e: any) => e.id === selectedProcessId)
    const pathArray = []
    pathArray.push(paths)

    let objectState = {
      dateType: date.times ? 'frequency' : 'specific',
      previewData: data,
      widgetEdition: true,
      isRegisterModalVisible: true,
      editingModalID: widgetID,
      widgetTitle,
      widgetType,
      selectedProcessId,
      selectedProcessData: pathArray,
      recurrency,
      confirmedAuditors: [],
      frequency: date.times ? date : {},
      specific: date.times ? {} : date,
    }

    if (componentKeys) {
      objectState = { ...objectState, componentKeys }
    }
    if (aggregator) {
      objectState = { ...objectState, aggregatorType: aggregator }
    }
    if (userIds) {
      let ids = userIds.map((e: string) => ({ id: e }))
      objectState = { ...objectState, confirmedUsers: ids }
    }
    if (minRange) {
      objectState = { ...objectState, minRange }
    }
    if (maxRange) {
      objectState = { ...objectState, maxRange }
    }
    if (auditorGuest) {
      objectState = { ...objectState, auditorGuest }
    }
    if (auditedGuest) {
      objectState = { ...objectState, auditedGuest }
    }
    if (auditedOut) {
      objectState = { ...objectState, auditedOut }
    }
    if (auditors) {
      let confirmedAuditors = auditors.map((e: string) => ({ id: e.id }))
      objectState = { ...objectState, confirmedAuditors }
    } else {
      if (data.auditors) {
        let confirmedAuditors = data.auditors.map((e: string) => ({ id: e }))
        objectState = { ...objectState, confirmedAuditors }
      }
    }
    this.setState(objectState)
    if (this.state.frequency && this.state.frequency.times) {
      document.querySelector('#InputNumber').value = this.state.frequency.times
    }
    document.querySelector('#widgetTitle').value = this.state.widgetTitle
  }

  createWidget = async () => {
    const { year } = this.state;
    const userArray = []
    let auditorArray
    if (this.state.confirmedUsers) {
      for (let user of this.state.confirmedUsers) {
        userArray.push(user.id)
      }
    }
    if (this.state.auditors && this.state.auditors.length > 0) auditorArray = this.state.auditors
    if (this.state.auditorsIds && this.state.auditorsIds.length > 0) auditorArray = this.state.auditorsIds.map(a => a.id)
    try {
      let WidgetQuery: any = undefined
      let DateType = this.state.dateType
      let specificDate = this.state.specific;

      const hourFromRAW = this.state.hourFrom ? new Date(this.state.hourFrom) : null
      const hourToRAW = this.state.hourTo ? new Date(this.state.hourTo) : null
      specificDate.hourFrom = hourFromRAW ? `${hourFromRAW.getHours()}:${(hourFromRAW.getMinutes() < 10 ? '0' : '') + hourFromRAW.getMinutes()}` : null
      specificDate.hourTo = hourToRAW ? `${hourToRAW.getHours()}:${(hourToRAW.getMinutes() < 10 ? '0' : '') + hourToRAW.getMinutes()}` : null

      if (this.state.widgetType === WidgetTypes.GOALS || this.state.widgetType === WidgetTypes.GOALS_CHART) {
        DateType = 'specific'
        specificDate = {
          from: new Date(year, 0, 1).getTime(),
          to: new Date(year, 11, 31).getTime()
        }
      }
      WidgetQuery = {
        id: Date.now(),
        type: this.state.widgetType,
        title: this.state.widgetTitle,
        processId: this.state.selectedProcessId,
        componentKeys: this.state.componentKeys,
        recurrence: this.state.recurrency
      }

      if (this.state.widgetType === WidgetTypes.RANGE_CHART) {
        const { minRange, maxRange } = this.state
        if (minRange) WidgetQuery.min = minRange

        if (maxRange) WidgetQuery.max = maxRange
      }
      if (this.state.widgetType === WidgetTypes.BAR_CHART) {
        const { minRange, maxRange } = this.state

        if (minRange) WidgetQuery.min = minRange

        if (maxRange) WidgetQuery.max = maxRange
      }
      if (this.state.widgetType === WidgetTypes.GOALS || this.state.widgetType === WidgetTypes.GOALS_CHART) {
        WidgetQuery.auditeds = userArray
      }
      if (this.state.widgetType === WidgetTypes.TABLE) {
        WidgetQuery.auditors = userArray
      }
      if ((this.state.widgetType !== WidgetTypes.GOALS || this.state.widgetType !== WidgetTypes.GOALS_CHART) && this.state.widgetType !== WidgetTypes.TABLE) {
        WidgetQuery.userIds = userArray
      }
      if (this.state.widgetType === WidgetTypes.RANGE_CHART) {
        WidgetQuery.aggregator = this.state.aggregatorType
      }
      if (this.state.widgetType === WidgetTypes.BAR_CHART) {
        WidgetQuery.aggregator = this.state.aggregatorType
      }
      if (DateType === 'frequency') {
        WidgetQuery.frequency = this.state.frequency
      }
      if (DateType === 'specific') {
        WidgetQuery.specific = specificDate
      }
      if (this.state.confirmedAuditors) {
        WidgetQuery.auditors = auditorArray
      }
      if (this.state.auditedGuest) {
        WidgetQuery.auditedGuest = this.state.auditedGuest
      }
      if (this.state.auditedOut) {
        WidgetQuery.auditedOut = this.state.auditedOut
      }
      if (this.state.auditorGuest) {
        WidgetQuery.auditorGuest = this.state.auditorGuest
      }
      if (this.props.pillar === 'EHSS') {
        await _EhssDashboardService.addWidget(this.state.id, this.props.unit, WidgetQuery)
      } else {
        await _DashboardService.addWidget(this.state.id, this.props.unit, WidgetQuery)
      }
      this.setState({ isRegisterModalVisible: false, widgets: undefined })
      await this.getDashboardFirstInfo()
      await this.dashboardRowGetter()
      this.clearWidgetstate()
      this.resetCheckboxStateHandler(true)


    } catch (error) {
      this.widgetSendErrorHandler()
    }
  }

  clearWidgetstate = async () => {
    this.setState({
      widgetType: undefined,
      widgetTitle: undefined,
      selectedProcessId: undefined,
      componentKeys: undefined,
      userIds: undefined,
      frequency: undefined,
      minRange: undefined,
      maxRange: undefined,
      auditedGuest: undefined,
      auditedOut: undefined,
      auditorGuest: undefined,
      aggregatorType: Aggregator.COUNT,
      widgetEdition: false
    })
  }

  duplicateWidget = async (infoObject: IWidgetProperties) => {
    const {
      widgetID,
      widgetTitle,
      frequency,
      data,
      widgetType,
      selectedProcessId,
      componentKeys,
      userIds,
      minRange,
      maxRange,
      recurrency,
      aggregator,
      auditedGuest,
      auditedOut,
      auditorGuest,
      auditors
    } = infoObject
    if (frequency.times !== undefined) {
      this.setState({ dateType: 'frequency' })
    }
    else this.setState({ dateType: 'specific' })
    this.setState({ previewData: data })
    const paths = this.state.processes.items.find((e: any) => e.id === selectedProcessId)
    const pathArray = []
    pathArray.push(paths)
    let objectState = {
      widgetEdition: true,
      editingModalID: widgetID,
      widgetTitle,
      frequency,
      widgetType,
      selectedProcessId,
      selectedProcessData: pathArray,
      recurrency
    }
    if (componentKeys) {
      objectState = { ...objectState, componentKeys }
    }
    if (aggregator) {
      objectState = { ...objectState, aggregatorType: aggregator }
    }
    if (userIds) {
      let ids = userIds.map((e: string) => ({ id: e }))
      objectState = { ...objectState, confirmedUsers: ids }
    }
    if (minRange) {
      objectState = { ...objectState, minRange }
    }
    if (maxRange) {
      objectState = { ...objectState, maxRange }
    }
    if (auditorGuest) {
      objectState = { ...objectState, auditorGuest }
    }
    if (auditedGuest) {
      objectState = { ...objectState, auditedGuest }
    }
    if (auditedOut) {
      objectState = { ...objectState, auditedOut }
    }
    if (auditors) {
      let confirmedAuditors = auditors
      objectState = { ...objectState, confirmedAuditors, auditors: confirmedAuditors }
    }
    this.setState(objectState)
  }

  editWidgetsModal = async () => {
    const { year } = this.state;
    const userArray = []
    if (this.state.confirmedUsers) {
      for (let user of this.state.confirmedUsers) {
        userArray.push(user.id)
      }
    }
    try {
      let WidgetQuery: any = undefined
      let DateType = this.state.dateType
      let specificDate = this.state.specific;

      const hourFromRAW = this.state.hourFrom ? new Date(this.state.hourFrom) : null
      const hourToRAW = this.state.hourTo ? new Date(this.state.hourTo) : null
      specificDate.hourFrom = hourFromRAW ? `${hourFromRAW.getHours()}:${(hourFromRAW.getMinutes() < 10 ? '0' : '') + hourFromRAW.getMinutes()}` : null
      specificDate.hourTo = hourToRAW ? `${hourToRAW.getHours()}:${(hourToRAW.getMinutes() < 10 ? '0' : '') + hourToRAW.getMinutes()}` : null

      if (this.state.widgetType === WidgetTypes.GOALS || this.state.widgetType === WidgetTypes.GOALS_CHART) {
        DateType = 'specific'
        specificDate = {
          from: new Date(year, 0, 1).getTime(),
          to: new Date(year, 11, 31).getTime()
        }
      }

      WidgetQuery = {
        id: Date.now(),
        type: this.state.widgetType,
        title: this.state.widgetTitle,
        processId: this.state.selectedProcessId,
        componentKeys: this.state.componentKeys,
        recurrence: this.state.recurrency
      }
      if (this.state.widgetType === WidgetTypes.RANGE_CHART) {
        const { minRange, maxRange } = this.state
        if (minRange) WidgetQuery.min = minRange
        if (maxRange) WidgetQuery.max = maxRange
      }
      if (this.state.widgetType === WidgetTypes.BAR_CHART) {
        const { minRange, maxRange } = this.state
        if (minRange) WidgetQuery.min = minRange
        if (maxRange) WidgetQuery.max = maxRange
      }
      if (this.state.widgetType === WidgetTypes.GOALS || this.state.widgetType === WidgetTypes.GOALS_CHART) {
        WidgetQuery.auditeds = userArray
      }
      if (this.state.widgetType === WidgetTypes.TABLE) {
        WidgetQuery.auditors = userArray
      }
      if ((this.state.widgetType !== WidgetTypes.GOALS || this.state.widgetType !== WidgetTypes.GOALS_CHART) && this.state.widgetType !== WidgetTypes.TABLE) {
        WidgetQuery.userIds = userArray
      }
      if (this.state.widgetType === WidgetTypes.RANGE_CHART) {
        WidgetQuery.aggregator = this.state.aggregatorType
      }
      if (this.state.widgetType === WidgetTypes.BAR_CHART) {
        WidgetQuery.aggregator = this.state.aggregatorType
      }
      if (DateType === 'frequency') {
        WidgetQuery.frequency = this.state.frequency
      }
      if (DateType === 'specific') {
        WidgetQuery.specific = specificDate
      }
      if (this.state.confirmedAuditors) {
        WidgetQuery.auditors = this.state.confirmedAuditors
      }
      if (this.state.auditedGuest) {
        WidgetQuery.auditedGuest = this.state.auditedGuest
      }
      if (this.state.auditedOut) {
        WidgetQuery.auditedOut = this.state.auditedOut
      }
      if (this.state.auditorGuest) {
        WidgetQuery.auditorGuest = this.state.auditorGuest
      }

      if (this.props.pillar === 'EHSS') {
        await _EhssDashboardService.editWidget(this.state.id, this.state.editingModalID, WidgetQuery, this.props.unit)
      } else {
        await _DashboardService.editWidget(this.state.id, this.state.editingModalID, WidgetQuery, this.props.unit)
      }
      this.setState({ isRegisterModalVisible: false, widgets: undefined })
      await this.getDashboardFirstInfo()
      await this.dashboardRowGetter()
      this.clearWidgetstate()
      this.resetCheckboxStateHandler(true)

    } catch (error) {
      this.widgetSendErrorHandler()
    }
  }

  widgetSendErrorHandler = () => {
    if (!this.state.widgetTitle || !this.state.widgetType || !this.state.selectedProcessId) {
      if (this.state.widgetTitle && this.state.widgetTitle.length > 75) {
        NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('widget.error.title.length'))
      }
      if (!this.state.widgetTitle) {
        NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('insert.title.message'))
      }
      if (!this.state.widgetType) {
        NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('select.widget.title'))
      }
      if (!this.state.selectedProcessId) {
        NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('select.process'))
      }
      if (!this.state.specific.from && !this.state.frequency.times) {
        NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('history.filter.startDate.message.required'))
      }
    }
    else {
      NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('widget.modal.error'));
    }
  }

  renderWidgetName() {
    if (this.state.widgetTitle && this.state.widgetTitle.length > 0) {
      return this.state.widgetTitle;
    }
    else return I18n.l('dashboard.nameWidget');
  }


  onClickViewPreview = async () => {
    let year = this.state.year ? this.state.year : new Date().getFullYear()
    this.setState({ loadPreview: true })
    const userArray = []
    let query: any
    if (this.state.users && this.state.users.length > 0) {
      for (let user of this.state.confirmedUsers) {
        userArray.push(user.id)
      }
    }
    if (this.state.dateType === 'frequency') {
      query = {
        unit: this.props.unit,
        owners: userArray,
        components: this.state.componentKeys,
        from: calcFrom(this.state.frequency.times, this.state.frequency.type)
      }
    } else if (this.state.widgetType === WidgetTypes.GROUP) {
      query = {}
      if (this.state.auditedGuest) {
        query.auditedGuest = this.state.auditedGuest
      }
      if (this.state.auditedOut) {
        query.auditedOut = this.state.auditedGuest
      }
      if (this.state.auditorGuest) {
        query.auditorGuest = this.state.auditorGuest
      }
    }
    else {
      const hourFromRAW = this.state.hourFrom ? new Date(this.state.hourFrom) : null
      const hourToRAW = this.state.hourTo ? new Date(this.state.hourTo) : null
      query = {
        unit: this.props.unit,
        owners: userArray,
        components: this.state.componentKeys,
        from: this.state.specific.from,
        to: this.state.specific.to,
        hourFrom: hourFromRAW ? `${hourFromRAW.getHours()}:${(hourFromRAW.getMinutes() < 10 ? '0' : '') + hourFromRAW.getMinutes()}` : null,
        hourTo: hourToRAW ? `${hourToRAW.getHours()}:${(hourToRAW.getMinutes() < 10 ? '0' : '') + hourToRAW.getMinutes()}` : null
      }
    }
    try {
      let data = undefined;
      if (this.state.widgetType === WidgetTypes.TABLE) {
        data = await _EhssTicketEvent.getDashboardData(this.state.selectedProcessId, query)
      }
      else {
        data = await _TicketEvent.getDashboardData(this.state.selectedProcessId, query)
      }
      if (this.state.widgetType === WidgetTypes.GOALS) {
        query.auditors = this.state.confirmedAuditors && this.state.confirmedAuditors.length > 0 && this.state.confirmedAuditors.map((u) => u.id)
        query.auditedOut = this.state.auditedOut
        query.auditedGuest = this.state.auditedGuest
        query.auditorGuest = this.state.auditorGuest
        data = await _EhssTicketEvent.getProcessGoals(query, this.props.unit, this.state.selectedProcessId, year)
      }
      if (this.state.widgetType === WidgetTypes.GOALS_CHART) {
        data = await this.getExistentWidgetsGoalsChart()
      }
      this.setState({
        previewData: data,
        loadPreview: false
      })
    } catch (error) {
      console.log('error preview', error);
      this.setState({ loadPreview: false })
    }
  }
  renderPreview() {
    if (this.state.widgetType) {
      if (this.state.loadPreview === false) {
        switch (this.state.widgetType) {
          case WidgetTypes.COUNTER:
            return (
              <div className='widget-style'>
                <Counter
                  deleteWidgetByIndex={this.deleteWidgetByIndex}
                  unit={this.props.unit}
                  widgetID={this.state.id}
                  id={this.state.id}
                  title={this.renderWidgetName()}
                  data={this.state.previewData ? this.state.previewData : 0}
                  isPreview={true}
                />
              </div>
            );
          case WidgetTypes.RANGE_CHART:
            return (
              <div className='image-style'>
                <RangeChart
                  aggregator={this.state.aggregatorType}
                  deleteWidgetByIndex={this.deleteWidgetByIndex}
                  unit={this.props.unit}
                  widgetID={this.state.id}
                  id={this.state.id}
                  title={this.renderWidgetName()}
                  data={this.state.previewData ? this.state.previewData : []}
                  dataType={this.state.dateType}
                  isPreview={true}
                  frequency={this.state.frequency}
                  specific={this.state.specific}
                />
              </div>
            );
          case WidgetTypes.BAR_CHART:
            return (
              <div className='image-style'>
                <BarChart
                  aggregator={this.state.aggregatorType}
                  deleteWidgetByIndex={this.deleteWidgetByIndex}
                  unit={this.props.unit}
                  widgetID={this.state.id}
                  id={this.state.id}
                  title={this.renderWidgetName()}
                  data={this.state.previewData ? this.state.previewData : []}
                  dataType={this.state.dateType}
                  isPreview={true}
                  frequency={this.state.frequency}
                  specific={this.state.specific}
                />
              </div>
            );
          case WidgetTypes.GROUP:
            return (
              <div className='image-style'>
                <List
                  deleteWidgetByIndex={this.deleteWidgetByIndex}
                  unit={this.props.unit}
                  widgetID={this.state.id}
                  id={this.state.id}
                  title={this.renderWidgetName()}
                  data={this.state.previewData ? this.state.previewData : []}
                  isPreview={true}
                />
              </div>
            );
          case WidgetTypes.LIST:
            return (
              <div className='image-style'>
                <List
                  deleteWidgetByIndex={this.deleteWidgetByIndex}
                  unit={this.props.unit}
                  widgetID={this.state.id}
                  id={this.state.id}
                  title={this.renderWidgetName()}
                  data={this.state.previewData ? this.state.previewData : undefined}
                  isPreview={true}
                />
              </div>
            );
          case WidgetTypes.GOALS:
            return (
              <div className='widget-style'>
                <Goals
                  deleteWidgetByIndex={this.deleteWidgetByIndex}
                  unit={this.props.unit}
                  widgetID={this.state.id}
                  id={this.state.id}
                  title={this.renderWidgetName()}
                  data={this.state.previewData ? this.state.previewData : []}
                  isPreview={true}
                />
              </div>
            );
          case WidgetTypes.TABLE:
            return (
              <div className='image-style'>
                <Table
                  processes={this.state.processes}
                  deleteWidgetByIndex={this.deleteWidgetByIndex}
                  unit={this.props.unit}
                  widgetID={this.state.id}
                  id={this.state.id}
                  title={this.renderWidgetName()}
                  data={this.state.previewData ? this.state.previewData : undefined}
                  isPreview={true}
                  processId={this.state.selectedProcessId}
                  recurrence={this.state.recurrency}
                />
              </div>
            )
          case WidgetTypes.GOALS_CHART:
            return (
              <div className='image-style'>
                <GoalsChart
                  deleteWidgetByIndex={this.deleteWidgetByIndex}
                  unit={this.props.unit}
                  widgetID={this.state.id}
                  id={this.state.id}
                  title={this.renderWidgetName()}
                  data={this.state.previewData ? this.state.previewData : []}
                  isPreview={true}
                />
              </div>
            )
          default:
            break;
        }
      }
      else {
        return <div><h3> {I18n.l('common.loadingData')}</h3></div>
      }
      return;
    }
    else return <img className='image-style' src={dashboardPreview}></img>;
  }

  onChangeTypeDate = async (evt: any) => {
    this.setState({ dateType: evt.target.value })
  }

  onChangeFrequencyType = async (evt: any) => {
    const frequency = Object.assign(this.state.frequency)
    frequency.type = evt;
    this.setState({ frequency: this.state.frequency })
  }
  onChangeFrequencyTimes = async (evt: any) => {

    const frequency = Object.assign(this.state.frequency)
    frequency.times = evt;
    this.setState({ frequency: this.state.frequency })

  }

  // onTimeRangeChanged = async (evt: any) => {
  //   if (evt.length === 0) {
  //     const specific = Object.assign(this.state.specific)
  //     specific.from = undefined;
  //     specific.to = undefined;
  //     this.setState({ specific: this.state.specific })
  //   }
  // }

  onTimeRangeOk = async (e: any) => {
    const nextStartTimeAndDate = (e[0] !== undefined) ? e[0].toDate().getTime() : undefined;
    const nextEndTimeAndDate = (e[1] !== undefined) ? e[1].toDate().getTime() : undefined;
    const specific = Object.assign(this.state.specific)
    specific.from = nextStartTimeAndDate;
    specific.to = nextEndTimeAndDate;
    this.setState({ specific: this.state.specific })
  }

  recurrencyHandler = async (checked: boolean) => {
    this.setState({ recurrency: checked })
  }

  auditedOutHandler = async (e: any) => {
    this.setState(prevState => ({ auditedOut: !prevState.auditedOut }))
  }
  auditedGuestHandler = async (e: any) => {
    this.setState(prevState => ({ auditedGuest: !prevState.auditedGuest }))
  }
  auditorGuestHandler = async (e: any) => {
    this.setState(prevState => ({ auditorGuest: !prevState.auditorGuest }))
  }
  returnHeader = () => {
    if (this.state.widgetType === WidgetTypes.GOALS_CHART) {
      return I18n.l('common.auditeds')
    }
    if (this.state.widgetType === WidgetTypes.TABLE) {
      return I18n.l('common.auditors')
    } else {
      return I18n.l('routes.users')
    }

  }

  setFrequencyType = async (type: number) => {
    let newFrequency = Object.assign({}, this.state.frequency, { type })
    this.setState({ frequency: newFrequency })
  }

  datepickerDates = () => {
    let from = moment(this.state.specific.from)
    let to = moment(this.state.specific.to)
    const returnedDates = [from, to]
    return returnedDates
  }

  render() {
    const { Option } = Select

    return (
      <Wrapper>
        <Modal
          visible={this.state.isRegisterModalVisible}
          width={'60vw'}
          footer={false}
          destroyOnClose={true}
          onCancel={this.toggleWidgetCreation} >
          <WidgetModalContent>
            <Row>
              <Col sm={12} md={12} xl={10} xxl={8}>
                <div className="left-side-container">
                  <div className="border-botom first">
                    <h3>{I18n.l('widget.title')}</h3>
                    <input className="ant-input-style" ref={this.state.widgetTitle} id="widgetTitle" defaultValue={this.state.widgetTitle} placeholder={I18n.l('widget.input.placeholder')} style={{ width: 280 }} onBlur={this.handleInput}></input>
                  </div>
                  <div className="border-botom section-above">
                    <h3>{I18n.l('dinamic.dashboard.chart.configuration')}</h3>
                    <Select value={this.state.widgetType} className="select" onChange={this.handleWidgetTypeChange} placeholder={I18n.l('dinamic.dashboard.chart.type')}>
                      <Option value={WidgetTypes.COUNTER} >{I18n.l('widgetTypes.counter')}</Option>
                      <Option value={WidgetTypes.LIST} >{I18n.l('widgetTypes.list')}</Option>
                      <Option value={WidgetTypes.RANGE_CHART} >{I18n.l('widgetTypes.range.chart')}</Option>
                      <Option value={WidgetTypes.BAR_CHART} >{I18n.l('widgetTypes.range.bar')}</Option>
                      <Option value={WidgetTypes.GROUP} >{I18n.l('widgetTypes.group')}</Option>
                      {this.props.pillar === 'EHSS' && <Option value={WidgetTypes.TABLE} >{I18n.l('widgetTypes.table')}</Option>}
                      {this.props.pillar === 'EHSS' && <Option value={WidgetTypes.GOALS} >{I18n.l('widgetTypes.goals')}</Option>}
                      {this.props.pillar === 'EHSS' && <Option value={WidgetTypes.GOALS_CHART} >{I18n.l('widgetTypes.goalsChart')}</Option>}
                      {/* <Option value={WidgetTypes.GROUP_CHART} ></Option> */}
                    </Select>
                  </div>
                  {this.state.widgetType && this.state.widgetType === WidgetTypes.RANGE_CHART &&
                    <div className="border-botom section-above">
                      <h3>{I18n.l('result.type')}</h3>
                      <Select className="select" defaultValue={this.state.aggregatorType} onChange={this.aggregatorHandler}>
                        <Option value={Aggregator.COUNT} >{I18n.l('common.count')}</Option>
                        <Option value={Aggregator.AVG} >{I18n.l('common.average')}</Option>
                        <Option value={Aggregator.SUM} >{I18n.l('common.sum')}</Option>
                      </Select>
                    </div>
                  }
                  {this.state.widgetType && this.state.widgetType === WidgetTypes.BAR_CHART &&
                    <div className="border-botom section-above">
                      <h3>{I18n.l('result.type')}</h3>
                      <Select className="select" defaultValue={this.state.aggregatorType} onChange={this.aggregatorHandler}>
                        <Option value={Aggregator.COUNT} >{I18n.l('common.count')}</Option>
                        <Option value={Aggregator.AVG} >{I18n.l('common.average')}</Option>
                        <Option value={Aggregator.SUM} >{I18n.l('common.sum')}</Option>
                      </Select>
                    </div>
                  }
                  {
                    this.state.widgetType && (this.state.widgetType === WidgetTypes.GOALS || this.state.widgetType === WidgetTypes.GOALS_CHART) &&
                    <div className="border-botom section-above">
                      <h3>{I18n.l('common.search.options')}</h3>
                      <div className="flex-column">
                        <Checkbox style={{ margin: '5px 0 5px 10px' }} onChange={this.auditedOutHandler} checked={this.state.auditedOut}>{I18n.l('widget.auditedOut')}</Checkbox>
                        <Checkbox style={{ margin: '5px 0 5px 10px' }} onChange={this.auditedGuestHandler} checked={this.state.auditedGuest}>{I18n.l('widget.auditedGuest')}</Checkbox>
                        <Checkbox style={{ margin: '5px 0 5px 10px' }} onChange={this.auditorGuestHandler} checked={this.state.auditorGuest}>{I18n.l('widget.auditorGuest')}</Checkbox>
                      </div>
                    </div>
                  }
                  {this.state.widgetType && this.state.widgetType === WidgetTypes.RANGE_CHART &&
                    <div className="border-botom section-above">
                      <h3>{I18n.l('dashboard.range.label')}</h3>
                      <div className="range-container">
                        <div className="input-formatter">
                          <p>{`${I18n.l('dashboard.range.minRange')}:`}</p>
                          <Input className="range-input" defaultValue={this.state.minRange} onBlur={(e: any) => this.setState({ minRange: e.target.value })} />
                        </div>
                        <div className="input-formatter">
                          <p>{`${I18n.l('dashboard.range.maxRange')}:`}</p>
                          <Input className="range-input" defaultValue={this.state.maxRange} onBlur={(e: any) => this.setState({ maxRange: e.target.value })} />
                        </div>
                      </div>
                    </div>
                  }
                  {this.state.widgetType && this.state.widgetType === WidgetTypes.BAR_CHART &&
                    <div className="border-botom section-above">
                      <h3>{I18n.l('dashboard.range.label')}</h3>
                      <div className="range-container">
                        <div className="input-formatter">
                          <p>{`${I18n.l('dashboard.range.minRange')}:`}</p>
                          <Input className="range-input" defaultValue={this.state.minRange} onBlur={(e: any) => this.setState({ minRange: e.target.value })} />
                        </div>
                        <div className="input-formatter">
                          <p>{`${I18n.l('dashboard.range.maxRange')}:`}</p>
                          <Input className="range-input" defaultValue={this.state.maxRange} onBlur={(e: any) => this.setState({ maxRange: e.target.value })} />
                        </div>
                      </div>
                    </div>
                  }
                  <div className="border-botom section-above">
                    <h3>{I18n.l('titles.liteProcesses')}</h3>
                    <CheckboxSearch value={this.state.selectedProcessId} reset={this.state.shouldResetCheckboxState} resetFunction={this.resetCheckboxStateHandler} radio={true} renderedData={this.state.processes} setProcess={this.setprocess} />
                  </div>
                  {this.state.widgetType !== WidgetTypes.GOALS && <div className="border-botom section-above">
                    <h3>{this.returnHeader()}</h3>
                    <Button onClick={() => this.setState({ isUsersModalVisible: true })} type="primary">{this.state.widgetType === WidgetTypes.GOALS_CHART || this.state.widgetType === WidgetTypes.TABLE ? I18n.l("common.add.auditeds") : I18n.l("common.add.users")}</Button>
                    <p className="margin-top">{`${this.state.widgetType === WidgetTypes.GOALS_CHART || this.state.widgetType === WidgetTypes.TABLE ? I18n.l('auditeds.count') : I18n.l('selected.users.count')} ${this.state.confirmedUsers ? this.state.confirmedUsers.length : 0}`}</p>
                    <Modal
                      visible={this.state.isUsersModalVisible}
                      style={{ top: 100 }}
                      width={'60vw'}
                      onCancel={this.handleUsersModalCancel}
                      onOk={this.handleUsersModalSave}
                    >
                      <UsersModalComponent
                        setSelectedIds={this.setSelectedIds}
                        nonSelectedIds={this.state.nonSelectedUsers}
                        confirmedUsers={this.state.confirmedUsers}
                        title={this.state.widgetType === WidgetTypes.GOALS || this.state.widgetType === WidgetTypes.GOALS_CHART || this.state.widgetType === WidgetTypes.TABLE ? 'common.auditeds' : undefined}
                      />
                    </Modal>
                  </div>}
                  {(this.state.widgetType === WidgetTypes.GOALS || this.state.widgetType === WidgetTypes.GOALS_CHART) &&
                    <div className="border-botom section-above">
                      <h3>{I18n.l('common.auditors')}</h3>
                      <Button onClick={() => this.setState({ isAuditorsModalVisible: true })} type="primary">{I18n.l('common.add.auditors')}</Button>
                      <p className="margin-top">{`${I18n.l('auditors.count')}: ${this.state.confirmedAuditors ? this.state.confirmedAuditors.length : 0}`}</p>
                      <Modal
                        visible={this.state.isAuditorsModalVisible}
                        style={{ top: 100 }}
                        width={'60vw'}
                        onCancel={this.handleAuditorsModalCancel}
                        onOk={this.handleAuditorsModalSave}
                      >
                        <UsersModalComponent
                          setSelectedIds={this.setSelectedAuditors}
                          nonSelectedIds={this.state.nonSelectedAuditors}
                          confirmedUsers={this.state.confirmedAuditors}
                          title={'common.auditors'}
                        />
                      </Modal>
                    </div>

                  }
                  <div className="border-botom section-above">
                    <h3>{I18n.l('lite.dashboard.component.select.title')}</h3>
                    {!this.state.selectedProcessId &&
                      <p className="warning">{I18n.l('lite.dashboard.process.needed.warning')}</p>}
                    <Button disabled={this.state.selectedProcessId ? false : true} onClick={() => this.setState({ isComponentsModalVisible: true })} type="primary" >{I18n.l('formflow.components.title')}</Button>
                    <Modal
                      visible={this.state.isComponentsModalVisible}
                      style={{ top: 100 }}
                      width={'60vw'}
                      destroyOnClose={true}
                      onCancel={() => this.setState({ isComponentsModalVisible: false })}
                      onOk={() => this.setState({ isComponentsModalVisible: false })}
                    >
                      <ComponentsModal selected={this.state.componentKeys} recurrency={this.state.recurrency} recurrencyHandler={this.recurrencyHandler} componentsToState={this.componentsToState} processData={this.state.selectedProcessData} />
                    </Modal>
                  </div>
                  <div className="section-above">
                    <h3>{I18n.l('users.date')}</h3>
                    {(this.state.widgetType === WidgetTypes.GOALS || this.state.widgetType === WidgetTypes.GOALS_CHART) &&
                      <Select style={{ width: '280px' }} defaultValue={moment().year()} onChange={this.handleYearChange} className="select-frequency">
                        <Select.Option value={moment().year()}>{`${moment().year()}`}</Select.Option>
                        <Select.Option value={(moment().year() - 1)}>{`${(moment().year() - 1)}`}</Select.Option>
                        <Select.Option value={moment().year() - 2}>{`${(moment().year() - 2)}`}</Select.Option>
                        <Select.Option value={moment().year() - 3}>{`${(moment().year() - 3)}`}</Select.Option>
                      </Select>
                    }
                    {(this.state.widgetType !== WidgetTypes.GOALS && this.state.widgetType !== WidgetTypes.GOALS_CHART) &&
                      <Radio.Group defaultValue={this.state.dateType} onChange={this.onChangeTypeDate} buttonStyle="solid">
                        <Radio.Button value="frequency">{I18n.l('dashboard.previousDate')}</Radio.Button>
                        <Radio.Button value="specific">{I18n.l('dashboard.specificDate')}</Radio.Button>
                      </Radio.Group>
                    }
                    {this.state.dateType === 'frequency' && this.state.widgetType !== WidgetTypes.GOALS && this.state.widgetType !== WidgetTypes.GOALS_CHART &&
                      <div className='box-date'>
                        <InputNumber id="InputNumber" defaultValue={this.state.frequency ? this.state.frequency.times : undefined} onChange={this.onChangeFrequencyTimes} placeholder='nº' className='input-number' min={0} />
                        <Select onChange={this.setFrequencyType} value={this.state.frequency ? this.state.frequency.type : FrequencyType.DAYS} className='select-frequency' >
                          <Select.Option value={FrequencyType.DAYS}>{I18n.l('frequency.days')}</Select.Option>
                          <Select.Option value={FrequencyType.MINUTES}>{I18n.l('frequency.minutes')}</Select.Option>
                          <Select.Option value={FrequencyType.HOUR}>{I18n.l('frequency.hours')}</Select.Option>
                          <Select.Option value={FrequencyType.MONTHS}>{I18n.l('frequency.months')}</Select.Option>
                          <Select.Option value={FrequencyType.YEARS}>{I18n.l('frequency.years')}</Select.Option>
                        </Select>
                        <span>{I18n.l('dashboard.behindDay')}</span>
                      </div>
                    }
                    {this.state.dateType === 'specific' && this.state.widgetType !== WidgetTypes.GOALS && this.state.widgetType !== WidgetTypes.GOALS_CHART &&
                      <div className='box-date'>
                        <AppContext.Consumer>
                          {({ locale }) => (<>
                            <RangePicker
                              defaultValue={this.state.specific ? this.datepickerDates() : undefined}
                              format={I18n.l('common.dateFormat')}
                              locale={(locale === "pt") ? pt_BR.DatePicker : undefined}
                              onChange={this.onTimeRangeOk}
                              placeholder={['-/-/- ', '-/-/- ']}
                              onOk={this.onTimeRangeOk}
                            />
                            <br />
                            <TimePickerStyled value={this.state.hourFrom} onChange={(v: any) => this.setState({ hourFrom: v })} />
                            <TimePickerStyled value={this.state.hourTo} onChange={(v: any) => this.setState({ hourTo: v })} />
                          </>)}
                        </AppContext.Consumer>
                      </div>
                    }
                  </div>
                </div>
              </Col>
              <Col sm={12} md={12} xl={14} xxl={16}>
                <div className='content-preview'>
                  <span className='label-style '>{this.renderWidgetName()}</span>
                  {this.renderPreview()}
                </div>

              </Col>
            </Row>
            <div className='buttons-style'>
              <Button onClick={this.onClickViewPreview} ghost style={{ marginRight: '10px' }} type="primary">{I18n.l('common.view')}</Button>
              <Button onClick={this.state.widgetEdition ? this.editWidgetsModal : this.createWidget} type="primary">{I18n.l('common.create')}</Button>
            </div>
          </WidgetModalContent>
        </Modal>
        {!this.state.widgets &&
          <div style={{ margin: '50px 0 0 0 ' }}>
            <h1>{I18n.l('common.loadingData')}</h1>
          </div>
        }
        {this.state.widgets && this.state.widgets.length >= 0 &&
          <>
            <Header>
              <button onClick={this.toggleWidgetCreation} className="button">{I18n.l('dinamic.dashboard.item.registry')}</button>
              <div className='search'>
                {/* <SearchComponent
               onSubmit={this.handleComponentSearch}
               placeholder='dinamic.dashboard.chart.search'
               buttonText='form.buttons.search'
             /> */}
              </div>
            </Header>
            <WidgetArea>
              <DragDropContext onDragEnd={this.onDragEnd}>
                {this.state.widgets.map((widgetRow: any, index: any) =>
                  <Droppable droppableId={`${index}`} key={`${index}`} direction="horizontal">

                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        {widgetRow.map((widget: any, i: any) => {
                          const indexDrag = parseInt(widget.position)
                          return (
                            <Draggable key={widget.position} draggableId={widget.position.toString()} index={indexDrag}>
                              {(provided, snapshot) => (
                                <Col className="widget-spacer" key={`${widget.id}-${widget.size}`} span={widget.size}>
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    key={widget.id}
                                  >
                                    <WidgetBox
                                      processes={this.state.processes}
                                      aggregator={this.state.aggregatorType}
                                      duplicateWidget={this.duplicateWidget}
                                      createWidget={this.createWidget}
                                      isRegisterModalVisible={this.state.isRegisterModalVisible}
                                      editWigdets={this.editWidgets}
                                      deleteWidgetByIndex={this.deleteWidgetByIndex}
                                      id={this.state.id}
                                      unit={this.props.unit}
                                      widget={widget}
                                      data={widget.data}
                                      recurrency={this.state.recurrency} />
                                  </div>
                                </Col>
                              )}
                            </Draggable>
                          )
                        })}
                      </div>
                    )}

                  </Droppable>
                )}
              </DragDropContext>
            </WidgetArea>
          </>
        }
      </Wrapper>
    )
  }
}
injectGlobal`
  .no-padding {
  .ant-popover-inner-content {
      padding: 0 !important;
    } 
  }
`
const Wrapper = styled.div`
width: 100%;
height: 200px;


.margin-top{
  margin: 15px 0;
}
`
const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const Header = styled.div`
display: flex;
width: 100%;

.button {
  height: 45px;
  width: 180px;
  border-radius: 25px;
  background: #335D7C;
  border: none;
  color: white;
  font-size: 1.2em;
  font-weight: 600;
  letter-spacing: 1.1px;
}

.button:hover {
  cursor: pointer;
}

.save {
  margin-left: auto;
}

.search{
  width: 600px !important;
  margin-left: 100px !important;
  margin-top: 3px !important;
}
`

const WidgetModalContent = styled.div`
width:100%;
.buttons-style {
  position: absolute;
  right: 20px;
  bottom: 20px;
}

.flex-column{
  display: flex;
  flex-direction: column;
}

.ant-input-style{
  width: 280px;
    font-size: 14px;
    font-variant: tabular-nums;
    color: rgba(0, 0, 0, 0.65);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    list-style: none;
    display: inline-block;
    position: relative;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    outline: 0;
    line-height: 1.3;
    padding: 7px;
}
}
.range-input{ 
  width: 130px; 
} 
.range-container{ 
  display: flex; 
  flex-direction: row; 
 
  .input-formatter{ 
    display: flex; 
    flex-direction: column; 
    align-items: flex-start; 
    margin: 0 15px; 
  } 
} 


.left-side-container{
    border: 1px solid #D6DDF4;
    background-color: #F0F4F7;
    height: 80vh;
    border-radius: 5px 0px 0px 5px;
    padding: 20px;
    margin: -24px 0 -24px -24px;
    overflow: auto;
    h3{
        color: #354D62;
        font-weight: 400 ;
        font-size: 1.5em ;
        margin-left: 5px;
    }

    .select{
        width: 280px;
    }
    .border-botom{
        border-bottom: solid rgba(123, 123, 123, 0.3) 2px;
        padding-bottom: 30px;
    }

    .section-above{
      margin-top: 30px;
      padding-bottom: 30px;
    }

    .warning{
      color: red;
      margin: 1px;
    }
    ::-webkit-scrollbar {
      width: 10px;
  }
  
    ::-webkit-scrollbar-track {
          background: #f1f1f1;
      }
      
    ::-webkit-scrollbar-thumb {
          background: #888;
      }
      
    ::-webkit-scrollbar-thumb:hover {
          background: #555;
      }
  
.box-date {
  background: #FFFFFF;
  border: 1px solid #B5B5B5;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 20px;
  width: 81%;
  margin-top: 1rem;
  .input-number{
    width: 25%;
    margin-right: 10px;
  }
  .select-frequency{
    width: 50%;
    padding-right: 10px;
  }
}
}

.content-preview{
  padding: 0 20px 0 40px;
  .image-style {
    width:100%;
    padding-top: 1rem;
    padding-bottom: 7vh;
  }
  .widget-style {
    width:50%;
    padding-top: 1rem;
    padding-bottom: 7vh;
  }
  .label-style {
    font-size: 20px;
    color: #354D62;
    margin-bottom: 1rem;
  }
  
}
`;

const WidgetArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 80px 0;



  .widget-spacer{
    margin: 10px 0;
  }
`

const TimePickerStyled = styled(TimePicker)`
  width: 115px;
  margin-top: 3px;
  &:nth-child(2n){
    margin-left: 3px;
  }
`